import api from "../../../interceptor/Interceptor";
import {
  DASHBOARD_SUMMARY,
  REQUEST_PENDING_APPROVAL,
  REQUEST_DELAYED_ORDERS,
} from "../../../api/ApiEndpoints";
import {
  fetchSummaryStart,
  fetchSummarySuccess,
  fetchSummaryFailure,
  fetchTablesStart,
  fetchTablesSuccess,
  fetchTablesFailure,
} from "../../reducer/dashboardReducer/DashboardReducer";

const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.error?.message ||
  error?.response?.data?.message ||
  error?.message ||
  fallback;

// .................... Aggregated stats + charts ...........................

export const fetchDashboardSummary = () => async (dispatch) => {
  dispatch(fetchSummaryStart());
  try {
    const response = await api.get(DASHBOARD_SUMMARY);
    const summary = response.data.summary;
    dispatch(fetchSummarySuccess(summary));
    return { success: true, summary };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to fetch dashboard summary");
    dispatch(fetchSummaryFailure(message));
    return { success: false, error: message };
  }
};

// .................... Tables (reuses existing request endpoints) ..........

export const fetchDashboardTables = () => async (dispatch) => {
  dispatch(fetchTablesStart());
  try {
    const [pendingRes, delayedRes] = await Promise.all([
      api.get(REQUEST_PENDING_APPROVAL),
      api.get(REQUEST_DELAYED_ORDERS),
    ]);
    const payload = {
      pendingApproval: pendingRes.data.requests || [],
      delayedOrders: delayedRes.data.requests || [],
    };
    dispatch(fetchTablesSuccess(payload));
    return { success: true, ...payload };
  } catch (error) {
    const message = extractErrorMessage(error, "Failed to fetch dashboard tables");
    dispatch(fetchTablesFailure(message));
    return { success: false, error: message };
  }
};